/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const AnswerKeyHeader = (props) => {
  const { lesson, page, questionNum, title = null } = props;

  // remove tab from the title
  const pagetitle = page?.title ? page.title.replace(/\t/g, '') : '';

  return (
    <>
      <Grid container className="w-full mb-24 px-16">
        <Grid item xs={6}>
          <Typography className="mt-2 text-md line-clamp-2 text-secondary">
            {lesson.title}
          </Typography>
          <Typography className="text-md font-semibold leading-5">
            {title != null ? title : `${pagetitle} - Question ${questionNum}`}
          </Typography>
        </Grid>

        <Grid item xs={6} className="text-right">
          <Typography className="mt-2 text-md line-clamp-2 text-secondary">
            Page ID:
          </Typography>
          <Typography className="text-md font-semibold leading-5">
            {page?.screen || 'N/A'}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default AnswerKeyHeader;
